// extracted by mini-css-extract-plugin
module.exports = {"blockMirror":"blockMirror_blockMirror__3EGfV"};